import React from "react";
import { Navigate } from "react-router-dom";
import { hasModuleAccess, getDefaultRoute } from "../config/rolePermissions";

/**
 * Redirects to the role's default route when the user lacks module access.
 */
const ProtectedRoute = ({
  module,
  moduleKeys,
  catalog,
  registeredModuleKeys,
  children,
}) => {
  if (!hasModuleAccess(moduleKeys, module)) {
    return (
      <Navigate
        to={getDefaultRoute(moduleKeys, catalog, registeredModuleKeys)}
        replace
      />
    );
  }
  return children;
};

export default ProtectedRoute;
